import { render } from "./WeekView.vue?vue&type=template&id=35adaec2&scoped=true"
import script from "./WeekView.vue?vue&type=script&lang=js"
export * from "./WeekView.vue?vue&type=script&lang=js"

import "./WeekView.vue?vue&type=style&index=0&id=35adaec2&scoped=true&lang=css"

import exportComponent from "/github/workspace/src/mealplanner-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35adaec2"]])

export default __exports__